import Swiper from 'swiper';
import {
    Navigation,
    A11y,
} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';

document.querySelectorAll('.swiperNewsSlider').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.swiperNewsBlock');
    const nextButton = container.querySelector('.swiperButtonNext');
    const prevButton = container.querySelector('.swiperButtonPrev');

    const updateFocusableSlides = (swiperInstance) => {
        swiperInstance.slides.forEach((slide) => {
            const isVisible = slide.classList.contains('swiper-slide-visible');
            slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
            slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
                if (!el.hasAttribute('data-initial-tabindex')) {
                    const initial = el.getAttribute('tabindex');
                    el.setAttribute('data-initial-tabindex', initial !== null ? initial : '');
                }
                if (isVisible) {
                    const initial = el.getAttribute('data-initial-tabindex');
                    if (initial === '') {
                        el.removeAttribute('tabindex');
                    } else {
                        el.setAttribute('tabindex', initial);
                    }
                } else {
                    el.setAttribute('tabindex', '-1');
                }
            });
        });
    };

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide'
        },
        // centeredSlides: true,
        loop: false,
        watchSlidesProgress: true,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 16,
            },
            450: {
                slidesPerView: 1.5,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 2.1,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 2.75,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 3.5,
                spaceBetween: 16,
            },
        },
        on: {
            init: function () {
                updateFocusableSlides(this);
            },
            slideChangeTransitionEnd: function () {
                updateFocusableSlides(this);
            },
            resize: function () {
                updateFocusableSlides(this);
            },
            loopFix: function () {
                updateFocusableSlides(this);
            },
        },
    });
});
